import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/admin-settings/")({
  component: lazyImportRouteComponent(
    () => import("./-components/AdminSettingsPage"),
    "AdminSettingsPage"
  ),
})
